import { Avatar, Box } from '@mui/material';
import { AppState, DefaultProps } from '../../types/types';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';

import { CustomerDataContext } from '../context/CustomerDataProvider';
import { useContext } from 'react';
import React from 'react';
import Dialog from '@mui/material/Dialog';
import { AnredeKz } from '../../types/apimodel';



export interface SimpleDialogProps {
    open: boolean;
    selectedValue: string;
    onClose: (value: string) => void;
}

function SimpleDialog(props: SimpleDialogProps) {
    const { onClose, selectedValue, open } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };


    const { vermittlerDaten } = useContext(CustomerDataContext);
    //console.log("vermittlerDaten: " + vermittlerDaten?.name1);
   // let vermittlerName: string = vermittlerDaten?.name1 || '';
    let vermittlerTelefon: string = vermittlerDaten?.tel || '';
    let email: string = vermittlerDaten?.email || '';
    //let vermittlerNr: string = (vermittlerDaten !== undefined && vermittlerDaten !== null && vermittlerDaten.agenturnummer !== undefined) ? vermittlerDaten.agenturnummer : '0';
    //let show: boolean = vermittlerDaten !== undefined && vermittlerDaten !== null && vermittlerNr !== '0';


    return (
        <Box className='popupContainer'>
            <Dialog onClose={handleClose} open={open} onClick={handleClose} className="popupContainer">
                <div className="popup">

                    {/*
    <div className="popup-content">

        <div className="vermittler-name">{vermittlerName}</div>
    </div>
*/}

                    {(email !== undefined && email !== '') &&
                        <a href={"mailto:" + email}><div className="popup-content-entry" >
                            <div className="vermittler-email"><MailIcon />{email}</div>
                        </div></a>}

                    <a href={"tel:" + vermittlerTelefon}>
                        <div className="popup-content-entry">
                            <div className="vermittler-telefon"><PhoneIcon />{vermittlerTelefon}</div>
                        </div>
                    </a>

                    <div className="popup-content-entry" onClick={handleClose}>
                        <div className="popup-close" >
                            Abbrechen
                        </div>
                    </div>
                </div>
            </Dialog>
        </Box>
    );
}


interface BrokerInfoProps extends DefaultProps {
    appState: AppState,
}

function BrokerInfo(props: BrokerInfoProps) {
    const { vermittlerDaten } = useContext(CustomerDataContext);
    //console.log("vermittlerDaten: " + vermittlerDaten?.name1);
    let vermittlerName:string = "";
    let anredeKz = String(vermittlerDaten?.anrede);
    if (anredeKz === AnredeKz[AnredeKz.FRAU] || anredeKz === AnredeKz[AnredeKz.FRAU_OHNE_ANDRUCK] || anredeKz === AnredeKz[AnredeKz.FRAEULEIN]  || anredeKz === AnredeKz[AnredeKz.FRAEULEIN_OHNE_ANDRUCK]  || anredeKz === AnredeKz[AnredeKz.HERR]  || anredeKz === AnredeKz[AnredeKz.HERR_OHNE_ANDRUCK]) {
        vermittlerName = '' + vermittlerDaten?.name1 + ' ' + vermittlerDaten?.name2;
    } else {
        vermittlerName = vermittlerDaten?.name1 || '';
    }
    let vermittlerTelefon: string = vermittlerDaten?.tel || '';
    let email: string = vermittlerDaten?.email || '';
    let vermittlerNr: string = (vermittlerDaten !== undefined && vermittlerDaten !== null && vermittlerDaten.agenturnummer !== undefined) ? vermittlerDaten.agenturnummer : '0';
    let show: boolean = vermittlerDaten !== undefined && vermittlerDaten !== null && vermittlerNr !== '0';

    if (props.appState.customizingId === 'rd') {
        show = false;
    }

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value: string) => {
        setOpen(false);

    };





    if (show === true) {
        return (

            <div className="vermittler-container">
                <Box sx={{ display: { sx: "none", xs: "none", md: "flex", lg: "flex" } }}>
                    <div className="vermittler-ansprechpartner">
                        <div className="vermittler-title">Ihr Ansprechpartner:</div>
                        <div className="vermittler-name">{vermittlerName}</div>
                        <div className="vermittler-telefon"><a href={"tel:" + vermittlerTelefon}><PhoneIcon />{vermittlerTelefon}</a></div>
                        {(email !== undefined && email !== '') &&
                            <div className="vermittler-email"><a href={"mailto:" + email}><MailIcon />{email}</a></div>}
                    </div>
                </Box>
                <div className="vermittler-avatar">
                    <Box sx={{ display: { sx: "none", xs: "none", md: "flex", lg: "flex" } }}>
                        <Avatar sx={{ width: 60, height: 60, objectFit: 'cover' }}
                            className="user-icon" alt="Hurz" src={(process.env.REACT_APP_BROKER_AVATAR_URL || '') + vermittlerNr + '.jpg'}>
                            <Box sx={{ "& img": { width: 60, height: 60, objectFit: 'cover' } }}>
                                <img src={process.env.REACT_APP_BROKER_FALLBACK_AVATAR_URL} alt="Ansprechpartner" />
                            </Box>
                        </Avatar>
                    </Box>
                    <Box sx={{ display: { sx: "flex", xs: "flex", md: "none", lg: "none" } }}>

                        <Avatar sx={{ width: 60, height: 60, objectFit: 'cover' }}
                            onClick={handleClickOpen}
                            className="user-icon" alt="Hurz" src={(process.env.REACT_APP_BROKER_AVATAR_URL || '') + vermittlerNr + '.jpg'}>
                            <Box sx={{ "& img": { width: 60, height: 60, objectFit: 'cover' } }}>
                                <img src={process.env.REACT_APP_BROKER_FALLBACK_AVATAR_URL} alt="Ansprechpartner" />
                            </Box>
                        </Avatar>
                        <SimpleDialog
                            open={open}
                            onClose={handleClose}
                            selectedValue={''} />


                    </Box>
                </div>
            </div>
        )
    } else {
        return (<></>);
    }
}
export default BrokerInfo;